import { render, staticRenderFns } from "./PushApprovalWaiting.vue?vue&type=template&id=4258a544&scoped=true&"
import script from "./PushApprovalWaiting.vue?vue&type=script&lang=js&"
export * from "./PushApprovalWaiting.vue?vue&type=script&lang=js&"
import style0 from "./PushApprovalWaiting.vue?vue&type=style&index=0&id=4258a544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4258a544",
  null
  
)

export default component.exports